import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { basenameFromPath } from "./lib/studio-scope";
import "./styles.css";

const root = document.getElementById("root");
if (root === null) {
  throw new Error("root element missing");
}
// The studio this tab is mounted in is the URL prefix (`/s/<slug>/`), read
// ONCE at boot: every <Link>, <Navigate> and navigate() is then relative to
// it, and `studioHeaders()` repeats the same slug on every /api call. A
// switch to another studio is a full navigation, never a router transition,
// so this value can never go stale within a page's lifetime
// (staff-person-login-studio-switcher, 2026-09-27; `lib/studio-scope.ts`).
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter basename={basenameFromPath(window.location.pathname)}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
